import SolutionDeviceGroups from './SolutionDeviceGroups';

export default SolutionDeviceGroups;
